import {BannerPlacementType} from '../types';

export const getBannerContainerId = (
  placement: BannerPlacementType,
  position?: number,
) => {
  return ['yan', placement, position].filter(Boolean).join('_');
};
